// extracted by mini-css-extract-plugin
export var divider = "_wp-0";